import styled from "styled-components"

const Title = styled.h2`

    &::after {
        background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
    }
`

const SectionAlert = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
`

const SectionAlertButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const SectionAlertContent = styled.div`
  & a::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & h2,
  & h3,
  & h4 {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const BandeauContainer = styled.section`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  & + div > div > div:first-of-type > h2 {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

export {
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
  BandeauContainer,
}
